import up = require('updeep');
import { patch } from './patch';
import initialState, { State } from '../state';
import { Dispatch } from 'redux';
import { handleUserApiError } from './handleUnexpectedError';
import * as selectors from '../selectors';
import { ExtraArguments } from '../extraArguments';
import { toast } from './toast';
import { StyleState } from '../../utils/styles';
import { getValidationErrors } from '../../utils/userApiHelper';
import { persistCompetitionSlug, resolveCompetitionSlug } from '../../utils/routerHelper';
import { trackEvent } from '../../utils/googleAnalytics';

export const postPasswordResetRequest = (params: { email: string }) => async (
  dispatch: Dispatch,
  getState: () => State,
  { i18n }: ExtraArguments
): Promise<boolean> => {
  const t = i18n.getFixedT(i18n.language, 'forgotPassword');
  const state = getState();
  const api = selectors.userApi(state);
  const competitionName = (state.competition && state.competition.name)
    || resolveCompetitionSlug();
  if (!competitionName) {
    toast({
      style: StyleState.Danger,
      title: t('Reset failed'),
      message: t('Could not determine which Challenge to reset. Open /ccsf/login and try again.')
    })(dispatch, getState);
    return false;
  }
  persistCompetitionSlug(competitionName);
  dispatch(patch({ spinner: true }));
  try {
    await api.postPasswordResetRequest(competitionName, params);
    dispatch(patch({
      spinner: false,
      forgotPasswordVE: up.constant(initialState.forgotPasswordVE)
    }));
    trackEvent('password_reset', 'request');
    toast({
      style: StyleState.Success,
      title: t('Check your email'),
      message: t('If an account exists for {{email}}, we sent a password reset link. Open that email and follow the link within one hour.', { email: params.email })
    }, 12000)(dispatch, getState);
    return true;
  } catch (err) {
    const validationErrors = await getValidationErrors(err);
    if (validationErrors) {
      dispatch(patch({
        forgotPasswordVE: validationErrors,
        spinner: false
      }));
      return false;
    }
    handleUserApiError(err)(dispatch, getState);
    return false;
  }
};
